import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterJobs, accountListUpdate } from "../../../actions/InstallationActions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from 'react-select';


const JobFilterSchema = Yup.object().shape({
    customerName: Yup.string().max(100, "Customer name must be less than 100 characters").trim(),
    installerName: Yup.string().when("showInstallerName", {
        is: true,
        then: Yup.string()
            .max(100, "Installer name must be less than 100 characters")
            .trim(),
        otherwise: Yup.string().trim(),
    }),
    startDate: Yup.date().min(
        new Date("1970-01-01"),
        "Start date should be after 1970-01-01"
    ),
    endDate: Yup.date()
        .min(new Date("1970-01-01"), "End date should be after 1970-01-01")
        .when("startDate", (startDate, schema) =>
            startDate && schema.min(startDate, "End date should be after start date")
        ),
    jobName: Yup.string().max(100, "Job name must be less than 100 characters").trim(),
});

export function JobFilterForm({listType, showInstallerName, cursort}) {

    const dispatch = useDispatch();

    const accountList = useSelector(state => state.accountList);

    const jobListReducerSelector = (state) => {
        switch (listType) {
            case 'assigned':
                return state.jobListAssigned;
            case 'unassigned':
                return state.jobListUnassigned;
            case 'completed':
                return state.jobListCompleted;
            default:
                return null;
        }
    };

    const jobList = useSelector(jobListReducerSelector);

    useEffect(() => {
        dispatch(accountListUpdate());
    }, []);

    const customerOptions = accountList
        .filter(account => !account.name.endsWith("(installer)"))
        .map(account => ({
            value: account.name,
            label: account.name,
        }));

    let installerOptions = [];
    if (showInstallerName) {
        installerOptions = accountList
            .filter(account => account.name.endsWith("(installer)"))
            .map(account => ({
                value: account.name,
                label: account.name.replace(" (installer)", ""),
            }));
    }


    const jobNameOptions = jobList
        .map(job => ({
            value: job.name,
            label: job.name,
        }));

    const onSubmit = (values, {setSubmitting}) => {
        setSubmitting(false);
        dispatch(FilterJobs(listType, values, cursort));
    };

    const initialValues = {
        customerName: "",
        installerName: "",
        startDate: "1970-01-02",
        endDate: "9999-12-31",
        jobName: "",
    };

  

    const [selectedplaceholderCustomer, setSelectedplaceholderCustomer] = useState("Enter customer name ");
    const [selectedplaceholderInstaller, setSelectedplaceholderInstaller] = useState("Enter installer name ");
    const [selectedplaceholderJobName, setSelectedplaceholderJobName] = useState("Enter job name ");
    const [customerSelectKey, setCustomerSelectKey] = useState(0);
    const [InstallerSelectKey, setInstallerSelectKey] = useState(0);
    const [JobNameSelectKey, setJobNameSelectKey] = useState(0);
   

    const clearForm = (resetForm) => {
      
        resetForm({ values: initialValues });

        setCustomerSelectKey((prevKey) => prevKey + 1);
        setInstallerSelectKey((prevKey) => prevKey + 1);
        setJobNameSelectKey((prevKey) => prevKey + 1);

        setSelectedplaceholderCustomer("Enter customer name")
        setSelectedplaceholderInstaller("Enter installer name")
        setSelectedplaceholderJobName("Enter job name")

    };

    return (
        <div className="page-section-no-padding">
            <Formik
                initialValues={initialValues}
                validationSchema={JobFilterSchema}
                onSubmit={onSubmit}
            >
                {({isSubmitting, values, resetForm, setFieldValue}) => (
                    <Form>
                        <h3 className="mt-2">Search with our filter form</h3>
                        <div className="text-secondary mt-2 mb-2">
                            Please enter your desired search criteria
                        </div>
                        <div className="form-group">
                            <label htmlFor="customerName">Customer Name:</label>
                            <div>
                                <Select
                                    key={`customerName_select_${customerSelectKey}`}
                                    name="customerName"
                                    options={customerOptions}
                                    placeholder={selectedplaceholderCustomer}
                                    className="basic-single"
                                    classNamePrefix="select"                         
                                    onChange={(option) => {
                                     
                                        setFieldValue("customerName", option.value);
                                    }}
                                />
                            </div>
                            <div>
                                <ErrorMessage
                                    name="customerName"
                                    className="text-danger"
                                    component="div"
                                />
                            </div>
                        </div>
                        {showInstallerName && (
                            <div className="form-group">
                                <label htmlFor="installerName">Installer Name:</label>
                                <div>

                                                                
                                    <Select
                                        key={`installerName_select_${InstallerSelectKey}`}
                                        name="installerName"
                                        options={installerOptions}
                                        placeholder={selectedplaceholderInstaller}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        onChange={(option) => {
                                            setFieldValue("installerName", option.value);
                                        }}
                                       
                                    />
                                </div>
                                <div>
                                    <ErrorMessage
                                        name="installerName"
                                        className="text-danger"
                                        component="div"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="form-group">
                            <label htmlFor="jobName">Job Name:</label>
                            <div>

                            
                                <Select
                                    key={`jobName_select_${JobNameSelectKey}`}
                                    name="jobName"
                                    options={jobNameOptions}
                                    placeholder={selectedplaceholderJobName}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    onChange={(option) => setFieldValue("jobName", option.value)}
                                />
                            </div>
                            <div>
                                <ErrorMessage
                                    name="jobName"
                                    className="text-danger"
                                    component="div"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="startDate">Start Date:</label>
                            <div>
                                <Field
                                    type="date"
                                    name="startDate"
                                    min="1970-01-01"
                                    className="form-control"
                                    value={values.startDate !== "1970-01-02" ? values.startDate : ""}
                                />
                            </div>
                            <div>
                                <ErrorMessage
                                    name="startDate"
                                    className="text-danger"
                                    component="div"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="endDate">End Date:</label>
                            <div>
                                <Field
                                    type="date"
                                    name="endDate"
                                    min="1970-01-01"
                                    className="form-control"
                                    value={values.endDate !== "9999-12-31" ? values.endDate : ""}
                                />
                            </div>
                            <div>
                                <ErrorMessage
                                    name="endDate"
                                    className="text-danger"
                                    component="div"
                                />
                            </div>
                        </div>
                        <div className="submit-button-container">
                            <button
                                type="button"
                                onClick={() => clearForm(resetForm)}
                                disabled={isSubmitting}
                                className="btn btn-secondary"
                            >
                                Clear
                            </button>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="btn btn-primary"
                            >
                                Search
                            </button>

                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}